module.exports = __webpack_public_path__ + "a6d35d859406c8b01a1b055ff68fe371.jpg";